import React, { useState } from "react";
import { Collapse, Divider, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ChevronDown from "src/icons/ChevronDown";
import palette from "src/theme/palette";

const Card = styled(Stack)({
  backgroundColor: palette.system[0],
  border: "1px solid",
  borderColor: palette.system[200],
  borderRadius: 8,
  overflow: "hidden"
});

const Header = styled(Stack)({
  height: 64,
  padding: "16px 24px",
  cursor: "pointer",
  flexDirection: "row",
  alignItems: "center",
  gap: 16
});

const kebab = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const CollapsibleSection = ({ title, subtitle, defaultExpanded = true, headerRight, children }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const testId = `section-${kebab(title)}`;

  return (
    <Card data-testid={testId}>
      <Header data-testid={`${testId}-header`} onClick={() => setIsExpanded((prev) => !prev)}>
        <ChevronDown
          strokeOpacity={1}
          stroke={palette.text[800]}
          style={{
            flexShrink: 0,
            transform: isExpanded ? "rotate(-180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease-in-out"
          }}
        />
        <Typography variant="h6" sx={{ color: palette.text[800], letterSpacing: "0.15px" }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: palette.text[700], letterSpacing: "0.15px" }}>
            {subtitle}
          </Typography>
        )}
        {headerRight && (
          <Stack direction="row" gap="16px" alignItems="center" sx={{ ml: "auto" }}>
            {headerRight}
          </Stack>
        )}
      </Header>
      <Collapse in={isExpanded} data-testid={`${testId}-content`}>
        <Divider sx={{ borderColor: palette.system[200] }} />
        <Stack sx={{ p: 3 }}>
          {children}
        </Stack>
      </Collapse>
    </Card>
  );
};

export default CollapsibleSection;
